export default __webpack_public_path__ + "static/media/Banner2.8debb11b.png";